import { 
  Box, 
  Card, 
  Radio, 
  Typography, 
  useTheme,
  Button,
} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useState } from "react";
import { useNavigate } from 'react-router';
import dairy from "../../../Assets/SVG/dairy.svg";
import HVAC from "../../../Assets/SVG/HVAC.svg";
import Tooltip from "../../Atom/Tooltip/Tooltip";
import { createFlexStyles } from '../../../theme/layoutStyles';

/**
 * Choose Industry component to choose the industry
 * Material UI version matching original layout exactly
 */
export const ChooseIndustry: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const flexStyles = createFlexStyles(theme);
  const [selectedIndustry, setSelectedIndustry] = useState<string>('');

  // Styles matching original component layout
  const styles = {
    // container: {
    //   p: theme.spacing(3),
    // },
    container: {
        ...flexStyles.flexColumn,
        width: '100%'
      },
      contentContainer: {
        ...flexStyles.flexColumn,
        justifyContent: 'space-between',
        padding: theme.spacing(3.75), // 30px equivalent
        flex: 1
      },
      titleContent: flexStyles.flexColumn,
    titleSection: {
        ...flexStyles.flexCenterBetween,
        alignItems: 'flex-start', // Override center alignment
        marginBottom: theme.spacing(3),
        width: '100%'
      },

      stepTitle: {
        color: theme.palette.primary.main,
        fontSize: '2rem', // 32px equivalent
        fontWeight: 'normal',
        margin: 0,
      },
      chooseTitle: {
        ...flexStyles.flexCenterGap1,
        fontSize: '1.5rem', // 24px equivalent
        fontWeight: 'normal',
        color: theme.palette.text.primary,
        margin: 0,
        paddingTop: theme.spacing(1.25) // 10px equivalent
      },
    infoIcon: {
      fontSize: '1.125rem',
      color: theme.palette.text.secondary,
    },
    cardsContainer: {
        ...flexStyles.flexCenter,
        justifyContent: 'center', // Explicit center for both axes
        padding: theme.spacing(3.75),
        flex: 1
    },
    industryCard: {
      ...flexStyles.flexCenterBetween,
      cursor: 'pointer',
      transition: 'all 0.2s ease-in-out',
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      pr: theme.spacing(2.5),
      margin: theme.spacing(2),
      minWidth: '350px',
      position: 'relative',
      '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: theme.shadows[2],
        borderColor: theme.palette.primary.main,
      },
    },
    selectedCard: {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.action.selected,
    },
    cardContent: {
      ...flexStyles.flexCenter,
      gap: theme.spacing(4),
      flex: 1
    },
    industryImage: {
      aspectRatio: 1/1,
      height: '100%'
    },
    industryText: {
      fontSize: '1.5rem',
      fontWeight: 'normal',
      color: theme.palette.text.primary,
    },
    radioContainer: flexStyles.flexCenter,
    previousButton: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
        padding: theme.spacing(1, 3),
        '&:hover': {
          backgroundColor: theme.palette.grey[50],
          borderColor: theme.palette.primary.main,
        },
      },
  };

  /**
   * Handle industry selection
   */
  const handleIndustrySelect = (industry: string) => {
    setSelectedIndustry(industry);
    
    if (industry === 'Dairy') {
      navigate("/ChooseMachine");
    }
    // Note: HVAC navigation can be added here when route is defined
  };

  const handlePreviousClick = () => {
    navigate("/Dashboard");
  };

  return (
    <Box sx={styles.container}>
      {/* Title Section */}
      <Box sx={styles.titleSection}>
        <Box sx={styles.titleContent}>
            <Typography component="h1" sx={styles.stepTitle}>
              Step.1
            </Typography>
            <Typography component="h2" sx={styles.chooseTitle}>
              Choose Industry
              <Tooltip name="Click on the industry of your type" />
            </Typography>
</Box>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              sx={styles.previousButton}
              onClick={handlePreviousClick}
            >
              Go Back
            </Button>
        </Box>

        

      {/* Industry Cards */}
      <Box sx={styles.cardsContainer}>
        {/* Dairy Industry Card */}
        <Card 
          sx={{
            ...styles.industryCard,
            ...(selectedIndustry === 'Dairy' ? styles.selectedCard : {}),
          }}
          onClick={() => handleIndustrySelect('Dairy')}
          elevation={0}
        >
          <Box sx={styles.cardContent}>
            <Box
              component="img"
              src={dairy}
              alt="Dairy industry"
              sx={styles.industryImage}
            />
            <Typography variant="h6" sx={styles.industryText}>
              Dairy
            </Typography>
          </Box>
          <Box sx={styles.radioContainer}>
            <Radio
              checked={selectedIndustry === 'Dairy'}
              value="Dairy"
              name="industry"
              inputProps={{ 'aria-label': 'Select Dairy industry' }}
            />
          </Box>
        </Card>

        {/* HVAC Industry Card */}
        <Card 
          sx={{
            ...styles.industryCard,
            ...(selectedIndustry === 'HVAC' ? styles.selectedCard : {}),
          }}
          onClick={() => handleIndustrySelect('HVAC')}
          elevation={0}
        >
          <Box sx={styles.cardContent}>
            <Box
              component="img"
              src={HVAC}
              alt="HVAC industry"
              sx={styles.industryImage}
            />
            <Typography variant="h6" sx={styles.industryText}>
              HVAC
            </Typography>
          </Box>
          <Box sx={styles.radioContainer}>
            <Radio
              checked={selectedIndustry === 'HVAC'}
              value="HVAC"
              name="industry"
              inputProps={{ 'aria-label': 'Select HVAC industry' }}
            />
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

export default ChooseIndustry; 